/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type VerifyOtpDto = {
    /**
     * OTP reference ID from register response
     */
    otp_id: string;
    /**
     * 6-digit OTP code
     */
    otp_code: string;
    /**
     * FCM/APNs push notification token
     */
    device_token?: string;
    /**
     * Device type
     */
    device_type?: VerifyOtpDto.device_type;
    /**
     * Device name
     */
    device_name?: string;
};
export namespace VerifyOtpDto {
    /**
     * Device type
     */
    export enum device_type {
        IOS = 'ios',
        ANDROID = 'android',
        WEB = 'web',
    }
}

